import { IconGift, Stack, Text } from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'
import {
  Rule,
  RuleActions,
  RuleContent,
  RuleDefaultActions,
  RuleDescription,
  RuleIcon,
  TagItem,
  TagsList,
} from 'ui'
import { Gift } from '../../../typings'
import { messages } from './messages'

type Props<T> = {
  onEdit: () => void
  onRemove: () => void
  config: Gift<T>
}

export function GiftView<T>(props: Props<T>) {
  const { onEdit, onRemove, config } = props
  const { items, maxQuantity, application } = config

  return (
    <Rule onClick={onEdit}>
      <RuleIcon>
        <IconGift />
      </RuleIcon>

      <RuleDescription>
        <FormattedMessage
          {...messages.description}
          values={{
            b: (content) => <Text variant="body">{content}</Text>,
            count: items.length,
          }}
        />
      </RuleDescription>

      <RuleContent>
        <Stack space="$space-2" fluid>
          <TagsList>
            {items.map((item, index) => (
              <TagItem key={index} item={item} />
            ))}
          </TagsList>

          <Text variant="detail" tone="secondary">
            <FormattedMessage
              {...messages.detail[application]}
              values={{
                quantity: maxQuantity,
                b: (content) => <Text variant="detail">{content}</Text>,
              }}
            />
          </Text>
        </Stack>
      </RuleContent>

      <RuleActions>
        <RuleDefaultActions onEdit={onEdit} onRemove={onRemove} />
      </RuleActions>
    </Rule>
  )
}
